import Dashboard from './Page/Dashboard';
import AvailableRewards from './Page/AvailableRewards';
import RewardPage from './Page/RewardPage';

export * from './Data';
export { NSAction } from './Action';
export { reducer } from './Store';

export const Pages = { Dashboard, AvailableRewards, RewardPage };
